export interface ITransplantedPatients {
    recipientCenterId: number,
    recipientCenterAlias: string,
    recipientId: number,
    transplantDate: string
    recipientAlias: string
    recipientType: string
    recipientAgeATOT: string
    recipientABO: string
    txpDonorCenterAlias: string
    txpDonorUnosID: string
    txpDonorAlias: string
    txpDonorAgeATOT: string
    txpDonorABO: string
    epletMM: string
    recipientCPRA: string
    wasDesensitized: string
    rejectionEpisodes: string
    graftFunctioning: string
    patientSurvival: string
    bmtMM: string
    hasAntibodyScreeningResults: string
    hasDsaDetected: string
}